module.exports = __webpack_public_path__ + "img/mypage.5d534c78.png";